module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 175.e7b19124.png";